import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=35d2f8a3&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=35d2f8a3&prod&lang=css"
import style1 from "./Support.vue?vue&type=style&index=1&id=35d2f8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2f8a3",
  null
  
)

export default component.exports